var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSitesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.014 18.6064C47.6498 18.2262 48.0264 17.5388 47.9986 16.8091C47.9707 16.0794 47.5428 15.4215 46.8798 15.0889L34.3633 8.21981C33.3519 7.71249 32.1124 8.10509 31.595 9.09671C31.0775 10.0883 31.4779 11.3035 32.4893 11.8109L41.734 17.0388L24.0361 27.6216L6.27701 17.0389L16.2321 11.8129C17.2442 11.3069 17.6464 10.0923 17.1304 9.09992C16.6143 8.10756 15.3754 7.7133 14.3633 8.21925L1.12273 15.0877C0.458296 15.4198 0.029261 16.0785 0.00143704 16.8092C-0.0263816 17.54 0.351368 18.2282 0.988696 18.608L22.9694 31.7063C23.6268 32.0981 24.4522 32.0975 25.109 31.7047L47.014 18.6064Z",
    fill: "#F2F2F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3633 0C20.4973 0 17.3633 3.13394 17.3633 7C17.3633 10.866 23.8633 19.9972 24.3633 20C24.8633 20.0025 31.3633 10.866 31.3633 7C31.3633 3.13394 28.2293 0 24.3633 0ZM24.3633 4.5078C25.7381 4.5078 26.8633 5.63299 26.8633 7.00779C26.8633 8.3826 25.7381 9.5078 24.3633 9.5078C22.9885 9.5078 21.8633 8.3826 21.8633 7.00779C21.8633 5.63299 22.9885 4.5078 24.3633 4.5078Z",
    fill: "#EE3B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitesIcon);
export default __webpack_public_path__ + "static/media/sites_icon.9a7d86f82aa1722553464397edf86400.svg";
export { ForwardRef as ReactComponent };